import {
  Button,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Stack,
  Text,
} from '@chakra-ui/react';

import type { AssignmentFormData } from '../../../types/assignmentTypes';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { DefaultTFuncReturn } from 'i18next';
import { Fragment } from 'react';
import HelpTextPopover from '../../overlay/HelpTextPopover';
import { useFormContext } from 'react-hook-form';

interface AutomationFormTypeSelectionMenuProps {
  label: string;
  buttonLabel: string | DefaultTFuncReturn;
  options: {
    label: string;
    helpText?: string;
    onClick: () => void;
  }[];
  hasError?: boolean;
}

export default function AutomationFormTypeSelectionMenu({
  label,
  buttonLabel,
  options,
  hasError = false,
}: AutomationFormTypeSelectionMenuProps) {
  const { clearErrors } = useFormContext<AssignmentFormData>();

  return (
    <Stack spacing={2}>
      <Text variant="createLabel" color={hasError ? 'error' : 'baseBlack'}>
        {label}
      </Text>

      <Menu matchWidth>
        <MenuButton
          as={Button}
          variant="createGoldOutline"
          borderColor={hasError ? 'error' : 'warmNeutral.200'}
          textAlign="left"
          rightIcon={<ChevronDownIcon boxSize={6} color={hasError ? 'error' : 'baseBlack'} />}
        >
          <Text fontSize="14px" fontWeight={500} color={hasError ? 'error' : 'baseBlack'}>
            {buttonLabel}
          </Text>
        </MenuButton>

        <MenuList
          padding={4}
          border="1px solid"
          borderColor="warmNeutral.200"
          borderRadius="6px"
          minWidth={0}
          maxHeight="300px"
          overflowY="auto"
          boxShadow="0px 4px 12px 0px #00000026"
        >
          {options.map((option, index) => (
            <Fragment key={option.label}>
              <MenuItem
                width="full"
                fontSize="14px"
                fontWeight={500}
                borderRadius="4px"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                _hover={{ backgroundColor: 'warmNeutral.100' }}
                _active={{ backgroundColor: 'warmNeutral.100' }}
                _focus={{ backgroundColor: 'warmNeutral.100' }}
                onClick={() => {
                  clearErrors('settings.type');
                  option.onClick();
                }}
              >
                {option.label}

                {option.helpText && (
                  <HelpTextPopover
                    popoverContent={
                      <Text fontSize="14px" fontWeight={400} lineHeight="160%">
                        {option.helpText}
                      </Text>
                    }
                  />
                )}
              </MenuItem>

              {index !== options.length - 1 && <MenuDivider color="warmNeutral.200" />}
            </Fragment>
          ))}
        </MenuList>
      </Menu>
    </Stack>
  );
}
